import { FlareXMLDeclaration } from '@common/flare/constants/flare-xml-declaration.constant';
import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { defaultToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { NodeIdAttrName, NodeIdMissingValue, NodeIdRootValue } from '@common/prosemirror/model/node-id';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { OperationAttrName } from '@common/prosemirror/operations/operations.constant';
import { getSchemaAttrs } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

/** TOC XML node names. */
export enum TocXmlNodeName {
  Toc = 'CatapultToc',
  Entry = 'TocEntry',
}

/** TOC XML nodes attribute names. */
export enum TocXmlAttributeName {
  Title = 'Title',
  Link = 'Link',
  Conditions = 'conditions',
  FrameName = 'FrameName',
  AbsoluteLink = 'AbsoluteLink',
}

export class TocSchemaPlugin extends SchemaPlugin {
  nodes: Dictionary<NodeSpec> = {
    doc: {
      content: TocXmlNodeName.Toc,
      toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
        let xml = FlareXMLDeclaration;

        for (let i = 0; i < node.childCount; i += 1) {
          const child = node.child(i);
          xml += (child.type.spec.toFlareXML ?? defaultToFlareXML)(child, options)
        }

        return xml;
      }
    },

    [TocXmlNodeName.Toc]: {
      content: 'block*',
      attrs: {
        [NodeIdAttrName]: { default: NodeIdRootValue, skipExport: true },
        [OperationAttrName]: { default: undefined, skipExport: true }
      },
      parseDOM: [{
        tag: TocXmlNodeName.Toc,
      }],
    },

    [TocXmlNodeName.Entry]: {
      group: 'block',
      content: 'block*',
      isVoidWhenEmpty: true,
      attrs: {
        [NodeIdAttrName]: { default: NodeIdMissingValue, skipExport: true },
        [TocXmlAttributeName.Title]: { default: undefined },
        [TocXmlAttributeName.Link]: { default: undefined },
        [TocXmlAttributeName.FrameName]: { default: undefined },
        [TocXmlAttributeName.Conditions]: { default: undefined },
      },
      parseDOM: [{
        tag: TocXmlNodeName.Entry,
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, [
            TocXmlAttributeName.Title,
            TocXmlAttributeName.Link,
            TocXmlAttributeName.FrameName,
            TocXmlAttributeName.Conditions
          ]);
        }
      }],
    },
  };
}
